<template>
  <v-menu v-model="jiraEditMode" offset-y :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-icon v-on="on" small :color="colorJiraTracker">
        mdi-jira
      </v-icon>
    </template>
    <v-card class="pt-1 pl-2 pr-2">
      <div class="d-flex align-center pt-2 pl-2 pr-2">
        <v-row>
          <v-col>
            <CustomTextField
              v-model="item.issueJiraAnalyst"
              label="Оцінка задачі"
              append-icon="search"
              readonly
              @click:append="redirectTrackerRef(item.issueJiraAnalyst)"
            />
          </v-col>
          <v-col>
            <CustomTextField
              v-model="item.issueJiraDev"
              label="Реалізація задачі"
              append-icon="search"
              readonly
              @click:append="redirectTrackerRef(item.issueJiraDev)"
            />
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  props: ["item"],
  data: () => ({
    jiraEditMode: false,
  }),
  computed: {
    colorJiraTracker() {
      return this.item.issueJiraAnalyst || this.item.issueJiraDev
        ? "blue darken-1"
        : "";
    },
  },
  methods: {
    redirectTrackerRef(jiraIssueKey) {
      if (!jiraIssueKey) return;
      window.open(
        `https://atominc.atlassian.net/browse/${jiraIssueKey}`,
        "_blank"
      );
    },
  },
};
</script>
